let isStatic = false;
const STICKY_CLASS = 'sticky-bar--is-static';
const SELECTORS = {
  stickyBar: '#sticky-bar',
  pageFooter: '.page-footer'
};

function stickyCtaBarObserver(stickyBarEl, triggerEl) {
  const scrollPosition = (window.scrollY || window.pageYOffset) + window.innerHeight;
  const triggerPosition = triggerEl.offsetTop;

  if (scrollPosition > triggerPosition + stickyBarEl.offsetHeight && !isStatic) {
    stickyBarEl.classList.add(STICKY_CLASS);
    isStatic = true;
  }

  if (scrollPosition < triggerPosition && isStatic) {
    stickyBarEl.classList.remove(STICKY_CLASS);
    isStatic = false;
  }
}

export const setupStickyCtaBar = (selectors = {}) => {
  const { stickyBarSelector = SELECTORS.stickyBar, triggerElementSelector = SELECTORS.pageFooter } = selectors;
  const stickyBarEl = document.querySelector(stickyBarSelector);
  const triggerEl = document.querySelector(triggerElementSelector);

  if (stickyBarEl && triggerEl) {
    document.addEventListener('scroll', () => stickyCtaBarObserver(stickyBarEl, triggerEl));
  }
};
